import { takeLatest, put, call, select } from 'redux-saga/effects';
import ReportActions, { ReportTypes } from '../Redux/ReportRedux';
import ApiResponseError from '../Services/ApiResponseError';

export function * salesReport(api, {input}) {
    try {
        const response = yield call(api.getReport, 'sales', input);
        if (!response.ok) {
            throw new ApiResponseError(response);
        }

        const data = response.data.data;
        yield put(ReportActions.salesReportSuccess(data));
    } catch (e) {
        yield put(ReportActions.salesReportFailure(e));
    }
}

export function * getReport(api, {name, input}) {
    try {
        const response = yield call(api.getReport, name, input);
        if (!response.ok) {
            throw new ApiResponseError(response);
        }

        const data = response.data.data;
        yield put(ReportActions.fetchReportSuccess(data));
    } catch (e) {
        yield put(ReportActions.fetchReportFailure(e));
    }
}

export function * watchReport(api) {
    yield takeLatest(ReportTypes.SALES_REPORT, salesReport, api);
    yield takeLatest(ReportTypes.FETCH_REPORT, getReport, api);
}



// WEBPACK FOOTER //
// ./src/Sagas/ReportSagas.js